// extracted by mini-css-extract-plugin
export var container = "OrderDetails_container__cseNO";
export var orderName = "OrderDetails_orderName__zIrzP";
export var product = "OrderDetails_product__MmmhO";
export var productsContainer = "OrderDetails_productsContainer__uHbVk";